import React, { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Link, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import SupportWidget from '../Support/SupportWidget';

const Layout = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!location?.pathname) return;
    if (location.pathname.startsWith('/login') || location.pathname.startsWith('/register')) return;
    try {
      sessionStorage.setItem('aot_last_route', location.pathname + location.search);
    } catch (_) {}
  }, [location.pathname, location.search]);

  const isAuctionsPage = String(location?.pathname || '').startsWith('/auctions');
  const auctionsContainerStyle = isAuctionsPage
    ? { maxWidth: 'none', width: '100%', margin: 0, padding: '0 20px' }
    : undefined;

  return (
    <div className="layout">
      {isAuthenticated ? (
        <Navbar />
      ) : (
        <nav className="navbar">
          <div className="navbar-brand">
            <Link to="/">Помощник по проведению торгов</Link>
          </div>
          <div className="navbar-actions">
            <div className="auth-links">
              <Link to="/login" className="nav-link">Вход</Link>
              <Link to="/register" className="nav-link">Регистрация</Link>
            </div>
          </div>
        </nav>
      )}
      <main className="main-content">
        <div
          className={`container ${isAuctionsPage ? 'container--auctions' : ''}`}
          style={auctionsContainerStyle}
        >
          {children}
        </div>
      </main>
      {isAuthenticated && <SupportWidget />}
    </div>
  );
};

export default Layout;
